import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {UsersPayments} from '../pages/e-commerce/user-activity/user-activity.component';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})


export class UserspaymentsService {

  constructor(private afs: AngularFirestore) { }

  // NOTE: Check for this one this is no where being used.
  getPendingUserspayments(){

    return this.afs.collection<UsersPayments>('UsersPaymentsDashboard',ref =>
    ref.where('Pending', '==',true)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as UsersPayments;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;
  }

}
